import {
  TableRow, TableCell, Checkbox, IconButton, Typography, Chip, Tooltip, Box,
} from '@mui/material'
import { MoreVert, Star, OpenInNew } from '@mui/icons-material'
import StatusBadge from '../common/StatusBadge'
import { formatDate, formatNumber } from '../../utils/format'

export default function PlanListRow({ plan, selected, onSelect, onOpen, onContextMenu }) {
  const {
    id, name, plant, status, isProductionPlan,
    createdAt, modificationCount, totalCases12mo, totalECs12mo,
  } = plan

  const statusLabel = status === 'APPROVED' ? 'APPROVED' : 'DRAFT'

  return (
    <TableRow
      hover
      selected={selected}
      onContextMenu={(e) => { e.preventDefault(); onContextMenu?.(e, plan) }}
      sx={{ height: 56, cursor: 'pointer', '&:hover': { bgcolor: 'surface.containerLow' } }}
    >
      <TableCell padding="checkbox">
        <Checkbox
          checked={!!selected}
          onChange={(e) => onSelect?.(plan, e.target.checked)}
          size="small"
          onClick={(e) => e.stopPropagation()}
        />
      </TableCell>
      <TableCell>
        <Typography
          variant="body2"
          sx={{ fontWeight: 600, cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
          onClick={() => onOpen?.(id)}
        >
          {name}
        </Typography>
      </TableCell>
      <TableCell>
        <Chip label={plant} size="small" variant="outlined" />
      </TableCell>
      <TableCell>
        <StatusBadge status={statusLabel} />
      </TableCell>
      <TableCell align="center">
        {isProductionPlan && (
          <Tooltip title="Production Plan">
            <Star sx={{ fontSize: 20, color: '#B45309' }} />
          </Tooltip>
        )}
      </TableCell>
      <TableCell>
        <Typography variant="body2" color="text.secondary">{formatDate(createdAt)}</Typography>
      </TableCell>
      <TableCell align="right">{modificationCount ?? 0}</TableCell>
      <TableCell align="right">{formatNumber(totalCases12mo)}</TableCell>
      <TableCell align="right">{formatNumber(totalECs12mo)}</TableCell>
      <TableCell align="right">
        <IconButton size="small" onClick={(e) => onContextMenu?.(e, plan)}>
          <MoreVert fontSize="small" />
        </IconButton>
      </TableCell>
    </TableRow>
  )
}
